import  { captureException, captureMessage } from "@sentry/react";
import { getErrorCode } from "./errorCodes";

export const isNetworkError = (error) => {
    if (!error) return false;
    
    const errorMessage = error?.message || '';
    const errorCode = error?.code || '';
    
    return errorCode === "NetworkError" || 
           errorMessage.includes("Network Error") || 
           errorMessage.includes("NetworkError") || 
           errorMessage.includes("network error") ||
           errorMessage.includes("Failed to fetch") ||
           errorMessage.includes("ERR_NETWORK") ||
           errorMessage.includes("ERR_INTERNET_DISCONNECTED") ||
           errorMessage.includes("ERR_CONNECTION_REFUSED") ||
           errorMessage.includes("ERR_CONNECTION_TIMED_OUT") ||
           errorMessage.includes("ERR_NAME_NOT_RESOLVED");
};

export const shouldLogToSentry = (error) => {
    return error && !isNetworkError(error);
};

const normalizeThrowableForSentry = (candidate, fallbackMessage) => {
    if (candidate instanceof Error) {
        return { throwable: candidate };
    }
    if (candidate != null && typeof candidate === 'object') {
        const msg =
            typeof candidate.message === 'string' && candidate.message
                ? candidate.message
                : fallbackMessage;
        return {
            throwable: new Error(msg),
            originalPayload: candidate,
        };
    }
    if (typeof candidate === 'string') {
        return { throwable: new Error(candidate) };
    }
    return { throwable: new Error(fallbackMessage) };
};

export const logToSentry = (options = {}) => {
    const {
        errorCode,
        message,
        error,
        tags = {},
        extra = {},
        level = 'error',
        type = 'exception',
        module,
        operation
    } = options;

    if (!error && !message) {
        console.warn('logToSentry: No error or message provided');
        return;
    }

    if (error && !shouldLogToSentry(error)) {
        return;
    }

    const finalErrorCode = errorCode || (module && operation ? getErrorCode(module, operation) : '000');
    const errorMessage = error?.message || message || 'Unknown error';
    const finalMessage = `${finalErrorCode} ${errorMessage}`;

    const sentryOptions = {
        tags: {
            errorType: finalErrorCode,
            module: module || 'Unknown',
            operation: operation || 'Unknown',
            ...tags
        },
        extra: {
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            url: window.location.href,
            ...extra
        },
        level
    };

    if (type === 'message') {
        captureMessage(finalMessage, sentryOptions);
    } else {
        const { throwable, originalPayload } = error
            ? normalizeThrowableForSentry(error, finalMessage)
            : { throwable: new Error(finalMessage) };
        if (originalPayload !== undefined) {
            sentryOptions.extra = {
                ...sentryOptions.extra,
                originalExceptionPayload: originalPayload,
            };
        }
        captureException(throwable, sentryOptions);
    }
};
